import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=271c8ef6&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=ts&"
export * from "./Modal.vue?vue&type=script&lang=ts&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=271c8ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c8ef6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCloseButton: require('/var/www/packages/theme/components/atoms/CloseButton.vue').default,MoleculesKESfModal: require('/var/www/packages/theme/components/molecules/KESfModal.vue').default})
